"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MessageOutlineIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.357 2.646C.674 2.119 1.037 1 1.889 1h12.222c.654 0 1.084.704.8 1.311l-5.688 12.17c-.376.805-1.533.635-1.675-.245L6.289 6.457 1.357 2.646zm2.074-.202l3.558 2.75 4.745-2.75H3.43zm9.38 1.032L8.664 12.35l-.958-5.917 5.105-2.958z",
    clipRule: "evenodd"
  })))
});
MessageOutlineIcon.displayName = 'MessageOutlineIcon';
var _default = exports.default = MessageOutlineIcon;